import { z } from 'zod';
import { EventTypeSchema } from './enums';
import { IdSchema, IsoDateSchema } from './validation';

const TimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Horário inválido (HH:mm)');

const EventBaseSchema = z.object({
  title: z.string().trim().min(3, 'Informe o título').max(120),
  description: z.string().trim().max(500).optional(),
  type: EventTypeSchema,
  startDate: IsoDateSchema,
  endDate: IsoDateSchema,
  allDay: z.boolean().default(true),
  startTime: TimeSchema.optional(),
  endTime: TimeSchema.optional(),
  classId: IdSchema.optional(),
});

interface EventTimingShape {
  startDate?: string;
  endDate?: string;
  allDay?: boolean;
  startTime?: string;
  endTime?: string;
}

function refineEvent<T extends z.ZodType<EventTimingShape>>(schema: T) {
  return schema.superRefine((value, ctx) => {
    if (value.startDate && value.endDate && value.endDate < value.startDate) {
      ctx.addIssue({
        code: 'custom',
        path: ['endDate'],
        message: 'A data final deve ser igual ou posterior à inicial',
      });
    }
    if (value.allDay === false && !value.startTime) {
      ctx.addIssue({ code: 'custom', path: ['startTime'], message: 'Informe o horário' });
    }
    if (
      value.allDay === false &&
      value.startTime &&
      value.endTime &&
      value.startDate === value.endDate &&
      value.endTime <= value.startTime
    ) {
      ctx.addIssue({
        code: 'custom',
        path: ['endTime'],
        message: 'O horário final deve ser posterior ao inicial',
      });
    }
  });
}

export const CreateEventSchema = refineEvent(EventBaseSchema);
export type CreateEventInput = z.input<typeof CreateEventSchema>;
export type CreateEventData = z.output<typeof CreateEventSchema>;

export const UpdateEventSchema = refineEvent(
  EventBaseSchema.partial().extend({ classId: IdSchema.nullable().optional() }),
);
export type UpdateEventInput = z.input<typeof UpdateEventSchema>;

export const ListEventsQuerySchema = z.object({
  from: IsoDateSchema,
  to: IsoDateSchema,
  type: EventTypeSchema.optional(),
});
export type ListEventsQuery = z.infer<typeof ListEventsQuerySchema>;

export const SchoolEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  type: EventTypeSchema,
  startsAt: z.string(),
  endsAt: z.string(),
  allDay: z.boolean(),
  classId: z.string().nullable(),
  className: z.string().nullable(),
  createdAt: z.string(),
});
export type SchoolEvent = z.infer<typeof SchoolEventSchema>;
